/* eslint-disable max-len */
import React, { PropsWithChildren } from 'react'
import { Calendar, GrownPlant, Pot, Seedling } from '~/components/Icons'
import { useTranslations } from '~/components/Locale'
import type { Product } from '~/types'

interface Props {
	product: Product
}

const Info: React.FC<PropsWithChildren<{ icon: string }>> = ({ icon, children }) => (
	<div className="flex items-center">
		<img src={icon} className="my-2 mr-6 h-12 align-middle" />
		<span>{children}</span>
	</div>
)

export const SeedInfo: React.FC<Props> = ({ product }) => {
	const info = {
		GERMINATION_TIME: product.seed_germination?.value,
		HARVEST_TIME: product.seed_harvest?.value,
		LIFESPAN: product.seed_lifespan?.value,
		SEEDS_PER_POT: product.seed_amount?.value
	}
	const t = useTranslations('react.seeds', info)
	if (!t) return null
	return (
		<div className="!mt-0 text-2xl">
			{info.GERMINATION_TIME && <Info icon={Seedling}>{t.germination_time}</Info>}
			{info.HARVEST_TIME && <Info icon={GrownPlant}>{t.harvest_time}</Info>}
			{info.LIFESPAN && <Info icon={Calendar}>{t.lifespan}</Info>}
			{info.SEEDS_PER_POT && <Info icon={Pot}>{t.seeds_per_pot}</Info>}
		</div>
	)
}
